.c2{max-width:100%;}